import { render, staticRenderFns } from "./yoWhatsapp.vue?vue&type=template&id=6d178f61"
import script from "./yoWhatsapp.vue?vue&type=script&lang=js"
export * from "./yoWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports